import { detect } from "detect-browser";
const browser = detect();

export function getDeviceName() {
  return `${browser.name}_${browser.version}`;
}
